import * as amplitude from "@amplitude/analytics-browser";
import {
  ErrorBoundary,
  LEVEL_CRITICAL,
  Provider as RollbarProvider,
} from "@rollbar/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import TagManager from "react-gtm-module";
import { Provider as ReduxProvider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import "./App.css";
import { AppRoutes } from "./appRoutes";
import { rollbarConfig } from "./common/config";
import { CustomTheme } from "./shared/components";
import { appStore } from "./store";

if (process.env.REACT_APP_GA_ID) {
  TagManager.initialize({
    gtmId: process.env.REACT_APP_GA_ID,
    events: {
      purchase: "purchase",
    },
  });
}

if (process.env.REACT_APP_AMPLITUDE_KEY) {
  amplitude.init(process.env.REACT_APP_AMPLITUDE_KEY, {
    defaultTracking: {
      attribution: false,
      pageViews: true,
      sessions: false,
      formInteractions: false,
      fileDownloads: false,
    },
  });
}

function App() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        cacheTime: Number.POSITIVE_INFINITY,
        staleTime: Number.POSITIVE_INFINITY,
      },
    },
  });

  return (
    <RollbarProvider config={rollbarConfig}>
      <QueryClientProvider client={queryClient}>
        <ErrorBoundary level={LEVEL_CRITICAL}>
          <CustomTheme>
            <ReduxProvider store={appStore}>
              <Router>
                <AppRoutes />
              </Router>
            </ReduxProvider>
          </CustomTheme>
        </ErrorBoundary>
        <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
      </QueryClientProvider>
    </RollbarProvider>
  );
}

export default App;
